import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M21.8549 8.34696C19.2329 5.69296 15.7329 4.23096 11.9999 4.23096C8.26689 4.23096 4.76689 5.69296 2.14489 8.34696C1.94989 8.54396 1.95189 8.85996 2.14789 9.05496C2.34389 9.24996 2.66189 9.24696 2.85489 9.04996C5.28889 6.58696 8.53589 5.23096 11.9999 5.23096C15.4639 5.23096 18.7109 6.58696 21.1449 9.04996C21.2429 9.14896 21.3719 9.19796 21.4999 9.19796C21.6269 9.19796 21.7539 9.14996 21.8519 9.05396C22.0479 8.85996 22.0499 8.54396 21.8549 8.34696Z"
      fill="currentColor"
    />
    <path
      d="M11.9999 8.73999C9.45989 8.73999 7.08489 9.73199 5.30989 11.534C5.11689 11.731 5.11889 12.048 5.31489 12.242C5.51189 12.434 5.82789 12.432 6.02289 12.237C7.60789 10.626 9.72989 9.73999 11.9999 9.73999C14.2699 9.73999 16.3919 10.626 17.9769 12.236C18.0749 12.335 18.2049 12.385 18.3329 12.385C18.4609 12.385 18.5869 12.337 18.6839 12.241C18.8809 12.047 18.8829 11.73 18.6899 11.533C16.9149 9.73199 14.5389 8.73999 11.9999 8.73999V8.73999Z"
      fill="currentColor"
    />
    <path
      d="M11.9999 13.248C10.6719 13.248 9.42088 13.77 8.47888 14.719C8.28388 14.915 8.28488 15.232 8.48088 15.426C8.67688 15.621 8.99388 15.621 9.18788 15.424C10.6959 13.908 13.3049 13.908 14.8129 15.424C14.9109 15.523 15.0389 15.571 15.1669 15.571C15.2949 15.571 15.4219 15.522 15.5199 15.425C15.7149 15.231 15.7159 14.914 15.5219 14.718C14.5789 13.771 13.3279 13.248 11.9999 13.248V13.248Z"
      fill="currentColor"
    />
    <path
      d="M13 18.769C13 19.321 12.552 19.769 12 19.769C11.448 19.769 11 19.321 11 18.769C11 18.217 11.448 17.769 12 17.769C12.552 17.769 13 18.217 13 18.769Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Wifi');

export default Icon;
